/**
 * @file ProgressRing.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-06-18
 * @modified 2026-06-18
 * @description Animated circular percentage ring (the same SVG technique as the
 *              dashboard Email Coverage widget), extracted as a reusable component.
 *              Props: percentage (0-100), label, color (CSS colour for the ring +
 *              text), size (px).
 */

import React from 'react';
import './ProgressRing.css';

const ARC = 'M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831';

function ProgressRing({ percentage = 0, label, color, size = 90 }) {
  const pct = Math.max(0, Math.min(100, Math.round(Number(percentage) || 0)));
  const style = { width: size };
  if (color) style['--ring-color'] = color;
  return (
    <div className="progress-ring" style={style}>
      <svg viewBox="0 0 36 36" className="progress-ring-chart">
        <path className="progress-ring-bg" d={ARC} />
        <path className="progress-ring-fill" strokeDasharray={`${pct}, 100`} d={ARC} />
        <text x="18" y="20.35" className="progress-ring-text">{pct}%</text>
      </svg>
      {label && <p className="progress-ring-label">{label}</p>}
    </div>
  );
}

export default ProgressRing;
